export const FUEL_CONSUMPTION_API_CONFIG = {
    BASE_PATH: '/report/pijar/fuel-consumption',
    ENDPOINTS: {
        VS_LACAK: '/vs-lacak',
    }
} as const;

export const getFuelConsumptionEndpoint = (endpoint: keyof typeof FUEL_CONSUMPTION_API_CONFIG.ENDPOINTS): string => {
    return `${FUEL_CONSUMPTION_API_CONFIG.BASE_PATH}${FUEL_CONSUMPTION_API_CONFIG.ENDPOINTS[endpoint]}`;
};
